import Vue from "vue";
import VueRouter from "vue-router";
import ListView from "../views/ListView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: ListView
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_URL,
  routes
});

export default router;
